<div class="kpi-card rounded-xl !p-[28px] flex flex-col !gap-[8px] min-h-[10rem] h-full">
  <div class="flex justify-between items-start flex-1">
    <div class="kpi-card-title text-base font-medium">
      {{ data.title }}
    </div>
    <div
      class="kpi-card-icon !w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
    >
      <img
        [src]="data.icon"
        [alt]="data.title"
        class="kpi-card-icon-svg w-full h-full object-contain"
      />
    </div>
  </div>
  <div class="kpi-card-value text-3xl font-bold leading-tight">
    {{ data.value }}
  </div>
  <div
    class="kpi-card-comparison text-sm font-normal"
    [class.kpi-card-comparison-positive]="data.isPositive"
    [class.kpi-card-comparison-negative]="!data.isPositive"
  >
    {{ data.comparison }}
  </div>
</div>
